/* pc-personalize.js — Prime Choice segment-aware personalization.
 * Ported from Alkaline Peptides ap-personalize.js (apseg pattern).
 * ?pcseg=<segment> reorders product grids client-side + (optional) hero swap.
 * Segment persists in localStorage; 100% graceful — no param/error → page as shipped.
 * Segment config: JSON in <script id="pc-segments-config"> (snippets/pc-segments.liquid). */
(function () {
  'use strict';
  var SEG_KEY = 'pc_pcseg';

  function loadSegments() {
    var el = document.getElementById('pc-segments-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function resolveSegment(SEGMENTS) {
    var segment = null;
    var sm = location.search.match(/[?&]pcseg=([a-z0-9-]{2,32})/);
    try {
      if (sm && SEGMENTS[sm[1]]) { segment = sm[1]; localStorage.setItem(SEG_KEY, segment); }
      else {
        var stored = localStorage.getItem(SEG_KEY);
        if (stored && SEGMENTS[stored]) segment = stored;
      }
    } catch (e) { if (sm && SEGMENTS[sm[1]]) segment = sm[1]; }
    return segment;
  }

  // Float the segment's products to the front of a grid (stable sort).
  function reorderByHandles(grid, handles) {
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.querySelector && el.querySelector('[data-pc-handle]');
    });
    if (!items.length) return;
    var rank = function (el) {
      var c = el.querySelector('[data-pc-handle]');
      var i = handles.indexOf(c ? c.getAttribute('data-pc-handle') : '');
      return i === -1 ? 999 : i;
    };
    items.map(function (el, i) { return { el: el, r: rank(el), i: i }; })
      .sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); })
      .forEach(function (x) { grid.appendChild(x.el); });
  }

  function reorderAllGrids(handles) {
    var onCollection = /^\/collections\//.test(location.pathname);
    var isMemberFavorites = /^\/collections\/(member-favorites|all)(\/|$)/.test(location.pathname);
    var grids = document.querySelectorAll('ul.product-grid, #product-grid');
    Array.prototype.forEach.call(grids, function (g) {
      // skip grids inside cart/checkout just in case
      if (g.closest && (g.closest('cart-drawer') || g.closest('.cart'))) return;
      // On collection pages, only personalize the main grid on /member-favorites
      // (other collections keep their merchandised/best-selling sort).
      if (onCollection && !isMemberFavorites && g.id === 'product-grid') return;
      reorderByHandles(g, handles);
    });
  }

  function swapHero(cfg) {
    if (document.documentElement.getAttribute('data-pc-hero-swap') !== 'on') return;
    if (!cfg.hero) return;
    // The hero tagline is the <h2> inside .banner-text ("Premium quality without the markup").
    var h = document.querySelector('.banner-text h2') || document.querySelector('.banner-heading');
    if (h) h.textContent = cfg.hero;
  }

  /* ---------- Name personalization (pcname) ---------- */
  var NAME_KEY = 'pc_pcname';

  function sanitizeName(raw) {
    if (!raw) return null;
    var s = String(raw).replace(/[^a-zA-Z]/g, '').slice(0, 20);
    if (s.length < 2) return null;
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }

  function resolveName() {
    // 1) logged-in customer (injected via Liquid in theme.liquid)
    var n = sanitizeName(window.pcCustomerName);
    if (n) return n;
    // 2) URL param, persisted
    var m = location.search.match(/[?&]pcname=([^&#]{1,40})/);
    if (m) {
      try { n = sanitizeName(decodeURIComponent(m[1])); } catch (e) { n = sanitizeName(m[1]); }
      if (n) { try { localStorage.setItem(NAME_KEY, n); } catch (e) {} return n; }
    }
    try { n = sanitizeName(localStorage.getItem(NAME_KEY)); } catch (e) { n = null; }
    return n;
  }

  // Append a red name span via textContent only (XSS-safe).
  function appendName(el, prefixText, name, upper) {
    if (!el || el.querySelector('.pc-name')) return;
    // trim trailing whitespace in existing text node(s)
    el.textContent = el.textContent.replace(/\s+$/, '');
    var pre = document.createTextNode(prefixText);
    var span = document.createElement('span');
    span.className = 'pc-name';
    span.style.color = '#E53935';
    span.textContent = upper ? name.toUpperCase() : name;
    el.appendChild(pre);
    el.appendChild(span);
  }

  function personalizeNames(name) {
    if (!name) return;
    // Headline targets matched by their current text (robust to section ids).
    var targets = [
      { match: /^welcome to prime choice!?$/i, strip: /!?\s*$/, suffix: ', ', tail: '!' },
      { match: /^prime choice (gets you healthy and )?saves you money!?$/i, strip: /!?\s*$/, suffix: ', ', tail: '!' },
      { match: /^you can trust prime choice$/i, suffix: ', ', upper: true },
      { match: /hero/, hero: true }
    ];
    var els = document.querySelectorAll('h1, h2, h3, .banner-text h2, .image-with-text-heading span');
    Array.prototype.forEach.call(els, function (el) {
      if (el.querySelector && el.querySelector('.pc-name')) return;
      var txt = (el.textContent || '').trim();
      if (!txt) return;
      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        if (t.hero) continue;
        if (t.match.test(txt)) {
          // only apply to the innermost element containing exactly this text
          if (el.children.length === 1 && el.children[0].textContent.trim() === txt) return; // apply on child instead
          var body = txt.replace(t.strip || /\s*$/, '');
          el.textContent = body;
          appendName(el, t.suffix, name, !!t.upper);
          if (t.tail) el.appendChild(document.createTextNode(t.tail));
          return;
        }
      }
    });
    // Hero tagline: append ", for you <Name>" to whatever text it currently shows
    var hero = document.querySelector('.banner-text h2');
    if (hero && !hero.querySelector('.pc-name')) {
      appendName(hero, ', for you ', name, false);
    }
  }

  function apply() {
    var SEGMENTS = loadSegments();
    var seg = null, cfg = null;
    if (SEGMENTS) {
      seg = resolveSegment(SEGMENTS);
      cfg = seg ? SEGMENTS[seg] : null;
    }
    if (cfg && cfg.handles) {
      try {
        reorderAllGrids(cfg.handles);
        swapHero(cfg);
        document.documentElement.setAttribute('data-pc-segment', seg);
        window.PCSegment = seg;
      } catch (e) { /* never break the page */ }

      // Related products load async via <product-recommendations>; re-apply when populated.
      var recs = document.querySelectorAll('product-recommendations');
      Array.prototype.forEach.call(recs, function (r) {
        var mo = new MutationObserver(function () {
          var grid = r.querySelector('ul.product-grid');
          if (grid && grid.children.length) {
            try { reorderByHandles(grid, cfg.handles); } catch (e) {}
            mo.disconnect();
          }
        });
        mo.observe(r, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 15000);
      });
    }

    // Name personalization runs after hero swap so it appends to swapped copy.
    try { personalizeNames(resolveName()); } catch (e) { /* never break the page */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
